import styled from 'styled-components/macro';
import * as colors from 'components/common/colorConstants';
import { mediumScreens } from 'components/common/fontElements';
import * as animations from 'components/common/animations';

export const Wrapper = styled.div`
  font-family: 'Roboto', sans-serif;
  width: 100%;
  height: 72px;
  padding: 7px 16px;
  background-color: ${colors.blue1};
  color: ${colors.whiteText};
  border: 0px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;

  h4 {
    font-weight: 500;
    font-size: 11px;
    ${animations.fadeInSlow};

    @media screen and (max-width: ${mediumScreens}) {
      font-size: 9px;
    }
  }

  p {
    font-style: normal;
    font-weight: 200;
    font-size: 10px;
    ${animations.fadeInSlow};

    @media screen and (max-width: ${mediumScreens}) {
      font-size: 8px;
    }
  }
`;
